import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './data/store';
import SupportSearchPage from './ui/page';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('support-search-app');
    if (!$root) return;

    ReactDOM.render(
        <Provider store={store}>
            <SupportSearchPage />
        </Provider>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {}

